import { Component, OnInit } from '@angular/core';
import { CbtService } from '../services/cbt.service';
import { Router } from '@angular/router';
import { LogService } from '../services/log.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { FeedbackService } from '../services/feedback.service';

@Component({
  selector: 'app-exam-score-summary',
  templateUrl: './exam-score-summary.component.html',
  styleUrls: ['./exam-score-summary.component.css']
})
export class ExamScoreSummaryComponent implements OnInit {

  constructor (private _cbtService: CbtService, private router: Router,
    private spinner: NgxSpinnerService,
    private auth: AuthService,
    private _feedbackService: FeedbackService,
    private user: UserService,
    public log: LogService) { }
  public submitted = false;
  public cbtDetails = [];
  public allSections = [];
  public filteredSections = [];
  public totalCorrectAnswers;
  public totalQuestionsAnswered;
  public overallTotal;
  public reason;
  ngOnInit () {
    this.log
      .addLog({
        action: "Access",
        component: "Exam Score Summary",
        details: `Accessed Exam Score Summary`,
      }).subscribe(data => { });

    this.submitted = this._cbtService.submitted;
    if (!this.submitted) {
      this.router.navigate(['/']);
    } else {
      let reason = sessionStorage.getItem('reason');
      if (reason) {
        if (reason == 'time') {
          this.reason = "Time Up!"
        } else if (reason == 'click') {
          this.reason = "Candidate submitted exam";
        } else if (reason == 'offence') {
          this.reason = "Offence meter full";
        }
      }
      this._cbtService.changeEmitted$.subscribe(data => {
        data.scoreDetails[4].map(s => {
          this.allSections.push({ section_title: s.section_title, correct_answers: 0, total_questions_in_section: s.questions.length });
        })
        this.allSections.filter((as, i) => {
          data.scoreDetails[0].filter((sd, j) => {
            if (sd.section_title === as.section_title) {
              this.allSections[i].correct_answers = sd.correct_answers;
            }
          })
        })
        this.totalCorrectAnswers = data.scoreDetails[1].total_correct_answers;
        this.totalQuestionsAnswered = data.scoreDetails[2].total_questions_answered;
        this.overallTotal = Math.round((this.totalCorrectAnswers / this.totalQuestionsAnswered) * 100);
        // console.log('total: ', this.overallTotal);
      })
    }
  }


  logout () {
    this.spinner.show();
    this.user.logout().subscribe(data => {
      this.spinner.hide();
      if (data.success) {
        this.log.addLog({
          action: "Log Out",
          component: "Exam Summary",
          details: `Logged Out (After exam was submitted)`,
        }).subscribe();
        this.router.navigate(['/login']);
        this.auth.setLoggedIn(false);
      } else {
        this._feedbackService.emitChange("Something went wrong", "failed-color");
      }
    }, _ => {
      this.spinner.hide();
      this._feedbackService.emitChange("Something went wrong", "failed-color");
    })
  }

}
